import React from 'react'
import {
  useNavigate,
  useLocation
} from "react-router-dom";

import { Carousel, IconButton } from "@material-tailwind/react";

import githubImg from '../assets/imgs/github.png';
import mainImg from '../assets/imgs/home-app.png';
import marketplaceImg from '../assets/imgs/marketplace.png';
import explorerImg from '../assets/imgs/explorer.png';
import leaderboardImg from '../assets/imgs/leaderboard1.png';
import telegramBotImg from '../assets/imgs/telegram-bot.png'

import image1 from '../assets/imgs/carosuel/1.png';
import image2 from '../assets/imgs/carosuel/2.png';
import image3 from '../assets/imgs/carosuel/3.png';
import image4 from '../assets/imgs/carosuel/4.jpeg';
import image5 from '../assets/imgs/carosuel/5.jpeg';
import image6 from '../assets/imgs/carosuel/6.jpeg';
import image7 from '../assets/imgs/carosuel/7.jpeg';
import image8 from '../assets/imgs/carosuel/8.jpg';
import image9 from '../assets/imgs/carosuel/9.jpg';
import image10 from '../assets/imgs/carosuel/10.png';
import image11 from '../assets/imgs/carosuel/11.png';

import Dashboard from '../components/Dashboard/Dashboard';
import { useTranslation } from 'react-i18next';
import { botUserName } from '../configs/constant';
import alkanesImg from '../assets/imgs/alkanes.png';
import cheekyImg from '../assets/imgs/cheeky.png';

export default function Wallet() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleConnectTelegram = () => {
    window.open(`https://telegram.me/${botUserName}?start=connect`, "_blank");
  };

  return (
    <div className="text-white mt-[65px] w-full max-w-[1800px] md:px-7 px-2 flex flex-row justify-center items-center">
      <div className="flex lg:flex-row flex-col-reverse sm:gap-[60px] gap-[40px] sm:mt-[60px] mt-[30px]">
        <div className="flex flex-col gap-5 max-w-[500px]">
          <div className="text-primary font-semibold sm:text-[36px] text-[30px] font-title">UNIVERSE WALLET</div>
          <div className="sm:text-[28px] text-[24px]">{t('Homepage Header')}</div>
          <div className="mt-3">{t('Homepage Subheader')}</div>

          <div className="grid md:grid-cols-2 grid-cols-1 gap-2 mt-10">
            <a href="https://chromewebstore.google.com/detail/tap-wallet/fjalkkkbjffhgdoheannkodafhemfdba" target="_blank">
              <div className="flex flex-row rounded-md border-solid border-[1px] border-gray-500 px-5 py-1 gap-3 min-w-[200px] cursor-pointer items-center">
                <img src="https://next-cdn.unisat.io/_/139/img/icon/chrome.svg"/>
                <div className="flex flex-col">
                  <span className="text-gray-500">{t('Download')}</span>
                  <span className="hover:text-primary-hover">Chrome Extension</span>
                </div>
              </div>
            </a>
            <a href="https://github.com/tapwallet/tapwallet" target="_blank">
              <div className="flex flex-row rounded-md border-solid border-[1px] border-gray-500 px-5 py-1 gap-3 min-w-[200px] cursor-pointer items-center">
                <img src={githubImg} className="w-[30px] h-[30px]"/>
                <div className="flex flex-col">
                  <span className="text-gray-500">{t('Download')}</span>
                  <span className = "hover:text-primary-hover">Github</span>
                </div>
              </div>
            </a>
          </div>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-2 w-full">
            <div className="flex flex-row rounded-md border-solid border-[1px] px-5 border-gray-500 w-full py-1 gap-3 min-w-[200px] cursor-pointer items-center" onClick={() => {navigate('/trade')}}>
              <img src={marketplaceImg} className="w-[30px] h-[30px] rounded-full"/>
              <div className="flex flex-col">
                <span className="hover:text-primary-hover py-2 pr-[52px]">{t('Marketplace')}</span>
              </div>
            </div>
            <div className="flex flex-row rounded-md border-solid border-[1px] w-full border-gray-500 px-5 py-1 gap-3 min-w-[200px] cursor-pointer items-center" onClick={() => {navigate('/explorer')}}>
              <img src={explorerImg} className="w-[30px] h-[30px] rounded-full"/>
              <div className="flex flex-col">
                <span className = "hover:text-primary-hover py-2 pr-10">{t('Explorer')}</span>
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-2 w-full">
            <div className="flex flex-row rounded-md border-solid border-[1px] px-5 border-gray-500 w-full py-1 gap-3 min-w-[200px] cursor-pointer items-center" onClick={() => {handleConnectTelegram()}}>
              <img src={telegramBotImg} className="w-[30px] h-[30px] rounded-full"/>
              <div className="flex flex-col">
                <span className="hover:text-primary-hover py-2 pr-[52px]">{t('Telegram Bot')}</span>
              </div>
            </div>
            <div className="flex flex-row rounded-md border-solid border-[1px] w-full border-gray-500 px-5 py-1 gap-3 min-w-[200px] cursor-pointer items-center" onClick={() => {window.open('https://dashboard.bitcoinuniverse.io', '_blank')}}>
              <img src={leaderboardImg} className="w-[30px] h-[30px]"/>
              <div className="flex flex-col">
                <span className = "hover:text-primary-hover py-2 pr-10">{t('Leaderboard')}</span>
              </div>
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/launchpad/1')}}>
              {t('OP-20 OG PASS: $OPZERO')}
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/inscribe/op_return')}}>
              {t('INSCRIBE OP_RETURN')}
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/trade/op20')}}>
              {t('TRADE OP-20')}
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/trade/mezcal')}}>
              {t('TRADE MEZCAL')}
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-2 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/alkanes/mint')}}>
              <img src={alkanesImg} className="w-[40px] h-[40px]"/>
              <span>{t('MINT ALKANES')}</span>
              <img src={cheekyImg} className="w-[40px] h-[40px]"/>
            </div>
          </div>
          {/* <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/inscribe/src101')}}>
              {t('DOMAIN NAME REGISTRATION')}
            </div>
          </div> */}
          {/* <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/presale/brc20/🝏')}}>
              BRC-20 🝏 PRESALE
            </div>
          </div> */}
          {/* <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/claim/brc20/tap')}}>
              CLAIM BRC-20 TAP
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/claim/brc20/🜷')}}>
              CLAIM BRC-20 🜷
            </div>
          </div> */}
          {/* <div className="flex md:flex-row flex-col gap-2 w-full">
            <div className="flex flex-row rounded-md w-full sm:py-2 py-3 sm:text-[20px] text-[16px] gap-3 min-w-[200px] cursor-pointer items-center justify-center bg-primary text-white font-bold" onClick={() => {navigate('/inscribe/dust20')}}>
              DUST-20: {t('DEPLOY')} | {t('MINT')} | {t('TRANSFER')}
            </div>
          </div> */}
        </div>
        <div>
          <Dashboard />
        </div>
        {/*
        <div className="max-w-[500px]">
          <Carousel
            className="rounded-xl"
            autoplay = {true}
            autoplayDelay = {3000}
            prevArrow={({ handlePrev }) => (
              <IconButton
                variant="text"
                color="white"
                size="lg"
                onClick={handlePrev}
                className="!absolute top-2/4 left-4 -translate-y-2/4"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                  />
                </svg>
              </IconButton>
            )}
            nextArrow={({ handleNext }) => (
              <IconButton
                variant="text"
                color="white"
                size="lg"
                onClick={handleNext}
                className="!absolute top-2/4 !right-4 -translate-y-2/4"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                  />
                </svg>
              </IconButton>
            )}
          >
            <img
              src= {image9}
              alt="image 2"
              className="h-full w-full object-cover cursor-pointer"
              onClick={() => navigate('/inscribe/dmtprvauth')}
            />
            <img
              src= {image10}
              alt="image 2"
              className="h-full w-full object-cover cursor-pointer"
              onClick={() => navigate('/inscribe/dmtprvauth')}
            />
            <img
              src= {image11}
              alt="image 2"
              className="h-full w-full object-cover cursor-pointer"
              onClick={() => navigate('/inscribe/dmtprvauth')}
            />
            <img
              src= {image1}
              alt="image 1"
              className="h-full w-full object-cover"
            />
            <img
              src= {image2}
              alt="image 2"
              className="h-full w-full object-cover"
            />
            <img
              src= {image3}
              alt="image 2"
              className="h-full w-full object-cover"
            />
            <img
              src= {image4}
              alt="image 2"
              className="h-full w-full object-cover"
            />
            <img
              src= {image5}
              alt="image 2"
              className="h-full w-full object-cover"
            />
            <img
              src= {image6}
              alt="image 2"
              className="h-full w-full object-cover"
            />
            <img
              src= {image7}
              alt="image 2"
              className="h-full w-full object-cover"
            />
          </Carousel>
        </div>
        */}
      </div>
    </div>
  )
}
